import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { OrderCardBodySummaryLabel } from 'components/Card'
import equal from 'fast-deep-equal'
import { DeliveryAddress } from 'types/storeShipping'
import { parsePostalCodeWithHyphen } from 'lib/helper'

const DeliveryOrderCardBodySummary: FC<DeliveryAddress> = React.memo(
  (props) => {
    const { name, name_kana, phone_number, postal_code, prefecture, city, street, building } = props
    return (
      <div className={styles.order__body__summary}>
        <OrderCardBodySummaryLabel label={'お客さまの配送先情報'} />
        <Spacer size={8} />
        <p className={text.font_small}>
          {name}（{name_kana}）様
          <br />
          {phone_number}
          <br />〒{parsePostalCodeWithHyphen(postal_code)}
          <br />
          {prefecture}
          {city}
          {street}
          {building}
        </p>
      </div>
    )
  },
  (prev, next) => equal(prev, next)
)

export default DeliveryOrderCardBodySummary
